module.exports = __webpack_public_path__ + "img/泛思特仓库(1).8a883692.jpg";